export var HhsAssignedGender;
(function (HhsAssignedGender) {
    HhsAssignedGender["F"] = "F";
    HhsAssignedGender["M"] = "M";
    HhsAssignedGender["U"] = "U";
})(HhsAssignedGender || (HhsAssignedGender = {}));
export var HhsAuthorizedBy;
(function (HhsAuthorizedBy) {
    HhsAuthorizedBy["Patient"] = "patient";
    HhsAuthorizedBy["Representative"] = "patientRepresentative";
})(HhsAuthorizedBy || (HhsAuthorizedBy = {}));
export var HhsBestTimeToCall;
(function (HhsBestTimeToCall) {
    HhsBestTimeToCall["Afternoon"] = "afternoon";
    HhsBestTimeToCall["Evening"] = "evening";
    HhsBestTimeToCall["Morning"] = "morning";
})(HhsBestTimeToCall || (HhsBestTimeToCall = {}));
export var HhsGenderIdentity;
(function (HhsGenderIdentity) {
    HhsGenderIdentity["Male"] = "M";
    HhsGenderIdentity["Female"] = "F";
    HhsGenderIdentity["FTM"] = "FTM";
    HhsGenderIdentity["MTF"] = "MTF";
    HhsGenderIdentity["NonConforming"] = "GNC";
    HhsGenderIdentity["Unknown"] = "U";
})(HhsGenderIdentity || (HhsGenderIdentity = {}));
export var HhsInitiator;
(function (HhsInitiator) {
    HhsInitiator["AssistRx"] = "ARX";
    HhsInitiator["Trialcard"] = "TC";
})(HhsInitiator || (HhsInitiator = {}));
export var HhsPhoneType;
(function (HhsPhoneType) {
    HhsPhoneType["Home"] = "home";
    HhsPhoneType["Mobile"] = "mobile";
    HhsPhoneType["Work"] = "work";
})(HhsPhoneType || (HhsPhoneType = {}));
export var HhsProduct;
(function (HhsProduct) {
    HhsProduct["Descovy"] = "Descovy";
    HhsProduct["Truvada"] = "Truvada";
})(HhsProduct || (HhsProduct = {}));
export var HhsRace;
(function (HhsRace) {
    HhsRace[HhsRace["White"] = 1] = "White";
    HhsRace[HhsRace["Black"] = 2] = "Black";
    HhsRace[HhsRace["Asian"] = 3] = "Asian";
    HhsRace[HhsRace["NativeAmerican"] = 4] = "NativeAmerican";
    HhsRace[HhsRace["PacificIslander"] = 5] = "PacificIslander";
    HhsRace[HhsRace["Multiple"] = 6] = "Multiple";
    HhsRace[HhsRace["NoAnswer"] = 9] = "NoAnswer";
})(HhsRace || (HhsRace = {}));
export var HhsStatus;
(function (HhsStatus) {
    HhsStatus["AlreadyEnrolled"] = "AlreadyEnrolled";
    HhsStatus["Enrolled"] = "Enrolled";
    HhsStatus["Expired"] = "Expired";
    HhsStatus["Rejected"] = "Rejected";
    HhsStatus["Unknown"] = "Unknown";
})(HhsStatus || (HhsStatus = {}));
export var HhsSource;
(function (HhsSource) {
    HhsSource["Interest"] = "interest";
    HhsSource["Prescriber"] = "prescriber";
})(HhsSource || (HhsSource = {}));
//# sourceMappingURL=HhsEnums.js.map